import Vue from 'vue'
import Vuex from 'vuex'
import userApi from '@/api/user.js'
import createPersistedState from "vuex-persistedstate";
import router from '@/router'

Vue.use(Vuex);

const store = new Vuex.Store({ 
  plugins: [createPersistedState()],   
    state: {
      //company details
      companyId: null,
      company: '',
      companyLogo: '',
      isLinkedAccount: false,
      companyAccount: null,
      fiscalPeriods: null,
      cutOffSettings: null,

      //team details      
      teamId: null,      
      team: '',
      teamLogo: '',

      //multi-team membership feature
      selectedTeamName: null,
      selectedTeamCompanyId: null,
      selectedTeamId: null,
      selectedTeamRole: null,
      selectedTeamPermissions: null,

      //user details
      dashboardTheme: null,
      userId: null,      
      parentUserId: null,
      pwd: '',
      userName: '',
      firstName: '',
      lastName: '',
      name: '',
      email: '',
      avatar: '',
      rlky: '',
      twoFA: null,
      appNotification: null,
      emailNotification: null,
      twoFAVerified: false,
      newDevice: null,
      isDeviceLoginCredentialExists: null,
      onBoarded: null,
      changedPassword: null,

      //personalized settings
      theme: '',
      color: '',      
      headerImg: '',
      leftNavMini: '',
      leftNavToggle: '',
      rightNavMini: '',
      rightNavToggle: '',
      
      //token details
      token: '',
      verificationCode: '',

      //offline clock-In details
      offlineClockIn: null,
      offlineClockOut: null,

      userProfileData: null,

      myCalendarContext: null,

      geoAddress: '',
      geoAddressAsOf: '',
      lastLatitude: null,
      lastLongitude: null,
      lastGeoAddress: '',
      
      hasTakenClockInPic: false,
      hasTakenClockInPicDate: null,
      hasTakenClockOutPic: false,
      hasTakenClockOutPicDate: null,

      avatarUrl: null,

      googleSignUp: null,
      facebookSignUp: null,
      emailSignUp: null,

      teamCount: null,
      userCount: null,
      accountName: null,
      accountKey: null,
      maxUsers: null,
      maxTeams: null,

      user_apps_list: null,

      loginStartTime: null,
      loginTimer: null,
      unclickedNotifCount: null,
      notifications: null, 

      selectedTwoZeroOneUser: null,
    },
    mutations: {
      // company details      
      setCompanyId(state, companyId) {
        state.companyId = companyId;
      },
      setCompanyName(state, company) {
        state.company = company;
      },
      setCompanyLogo(state, companyLogo) {
        state.companyLogo = companyLogo;
      },
      setIsLinkedAccount(state, isLinkedAccount) {
        state.isLinkedAccount = isLinkedAccount;
      },
      setCompanyAccount(state, companyAccount) {
        state.companyAccount = companyAccount
      },
      setFiscalPeriods(state, fiscalPeriods) {
        state.fiscalPeriods = fiscalPeriods
      },
      setCutOffSettings(state, cutOffSettings) {
        state.cutOffSettings = cutOffSettings
      },
      
      //team details         
      setTeamId(state, teamId) {
        state.teamId = teamId;
      },           
      setTeamName(state, team) {
        state.team = team;
      },
      setTeamLogo(state, teamLogo) {
        state.teamLogo = teamLogo;
      },

      //multi-team membership feature
      setSelectedTeamCompanyId(state, selectedTeamCompanyId) {
        state.selectedTeamCompanyId = selectedTeamCompanyId;
      },
      setSelectedTeamName(state, selectedTeamName) {
        state.selectedTeamName = selectedTeamName;
      },
      setSelectedTeamId(state, selectedTeamId) {
        state.selectedTeamId = selectedTeamId;
      },
      setSelectedTeamRole(state, selectedTeamRole) {
        state.selectedTeamRole = selectedTeamRole;
      },
      setSelectedTeamPermissions(state, selectedTeamPermissions) {
        state.selectedTeamPermissions = selectedTeamPermissions;
      },
      
      //user details
      setDashboardTheme(state, dashboardTheme) {
        state.dashboardTheme = dashboardTheme
      },
      setUserId(state, userId) {
        state.userId = userId;
      },    
      setParentUserId(state, parentUserId) {
        state.parentUserId = parentUserId;
      },
      setPassword(state, pwd) {
        state.pwd = pwd
      },
      setUserName(state, userName) {
        state.userName = userName;
      },   
      setFirstName(state, firstName) {
        state.firstName = firstName;
      },
      setLastName(state, lastName) {
        state.lastName = lastName;
      },
      setName(state, name) {
        state.name = name;
      }, 
      setEmail(state, email) {
        state.email = email;
      },
      setAvatar(state, avatar) {
        state.avatar = avatar;
      },
      setRoleKey(state, rlky) {
        state.rlky = rlky;
      },      
      setTwoFA(state, twoFA) {
        state.twoFA = twoFA;
      },
      setAppNotification(state, appNotification) {
        state.appNotification = appNotification;
      },
      setEmailNotification(state, emailNotification) {
        state.emailNotification = emailNotification;
      },
      setTwoFAVerified(state, twoFAVerified) {
        state.twoFAVerified = twoFAVerified;
      },
      setNewDevice(state, newDevice) {
        state.newDevice = newDevice;
      },
      setIsDeviceLoginCredentialExists(state, isDeviceLoginCredentialExists) {
        state.isDeviceLoginCredentialExists = isDeviceLoginCredentialExists;
      },
      
      setOnBoarded(state, onBoarded) {
        state.onBoarded = onBoarded;
      },
      setChangedPassword(state, changedPassword){
        state.changedPassword = changedPassword
      },
      
      //personalized settings
      setTheme(state, theme) {
        state.theme = theme;
      },
      setColor(state, color) {
        state.color = color;
      },
      setHeaderImage(state, image) {
        state.headerImg = image;
      },
      setLeftNavMini(state, leftNavMini) {
        state.leftNavMini = leftNavMini;
      },
      setLeftNavToggle(state, leftNavToggle) {
        state.leftNavToggle = leftNavToggle;
      },
      setRightNavMini(state, rightNavMini) {
        state.rightNavMini = rightNavMini;
      },
      setRightNavToggle(state, rightNavToggle) {
        state.rightNavToggle = rightNavToggle;
      },
            
      //token details     
      setToken(state, token) {
        state.token = token;
      },
      setVerificationCode(state, code) {
        state.verificationCode = code;
      },      

      //offline clock-In details
      setOfflineClockIn(state, offlineClockIn) {
        state.offlineClockIn = offlineClockIn
      },
      setOfflineClockOut(state, offlineClockOut) {
        state.offlineClockOut = offlineClockOut
      },
      
      setUserProfileData(state, data) {
        state.userProfileData = data
      },
      setmyCalendarContext(state, data) {
        state.myCalendarContext = data
      },
      setGeoAddress(state, data) {
        state.geoAddress = data
      },
      setGeoAddressAsOf(state, data) {
        state.geoAddressAsOf = data
      },
      setLastLatitude(state, data) {
        state.lastLatitude = data
      },
      setLastLongitude(state, data) {
        state.lastLongitude = data
      },
      setLastGeoAddress(state, data) {
        state.lastGeoAddress = data
      },
      sethasTakenClockInPic(state, data) {
        state.hasTakenClockInPic = data
      },
      sethasTakenClockInPicDate(state, data) {
        state.hasTakenClockInPicDate = data
      },
      sethasTakenClockOutPic(state, data) {
        state.hasTakenClockOutPic = data
      },
      sethasTakenClockOutPicDate(state, data) {
        state.hasTakenClockOutPicDate = data
      },

      setGoogleSignUp(state, data) {
        state.googleSignUp = data
      },
      setFacebookSignUp(state, data) {
        state.facebookSignUp = data
      },
      setEmailSignUp(state, data) {
        state.emailSignUp = data
      },
      setAvatarUrl(state, data) {
        state.avatarUrl = data
      },

      setTeamCount(state, data) {
        state.teamCount = data
      },
      setUserCount(state, data) {
        state.userCount = data
      },
      setAccountName(state, data) {
        state.accountName = data
      },
      setAccountKey(state, data) {
        state.accountKey = data
      },
      setMaxUsers(state, data) {
        state.maxUsers = data
      },
      setMaxTeams(state, data) { 
        state.maxTeams = data
      },
      
      //apps access list
      setUserAppsList(state, data) {
        state.user_apps_list = data
      },
      setLoginStartTime(state, data) {
        state.loginStartTime = data
      },
      setLoginTimer(state, data) {
        state.loginTimer = data
      },
      removeNotifCount(state, data) {
        state.unclickedNotifCount = null
      },
      setUnclickedNotifCount(state, data) {
        state.unclickedNotifCount = parseInt(data)
      },
      setNotificationsData(state, data) {
        state.notifications = data
      },
      setSelectedTwoZeroOneUser(state, data) {
        state.selectedTwoZeroOneUser = data
      },
    },
    actions: {     
      async updateTheme() {
        try{
          const data = {"theme": store.state.theme}
          const response = await userApi.updateById(data);
        }catch(error){
          throw error
        }
      },
      //Users - selected userid goging to User/Profile
      async getUserProfile({commit}, data) {
        try{
          const response = await userApi.getUserById(data.id)
          commit('setUserProfileData', response)
          router.push("/user/profile");
        }catch(error){
          throw error
        }
       
      }
    },
    getters: {
      favorites: state => {
        const favorites = []
        if (state.user_apps_list) {
          state.user_apps_list.forEach(app => {
                app.appPages.forEach(page => {
                    if (page.favorite) {
                        favorites.push(page)
                    }
                })
            })
        }
        return favorites
      }
    }
  });
  
  export default store;